/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react/prop-types */
import React, { useRef, useEffect } from 'react';
import { View, Text, StyleSheet, Pressable } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import ModalizeBase from '@web-components/modals/ModalizeBase';
import WithLocalSvg from '@web-components/common/WithLocalSvg';
import { isWeb } from '~global/screens';
const dismissSource = require('~assets/img/common/modal-dismiss.svg');

const ModalActionReview = (props) => {
  const dispatch = useDispatch();
  const navigation = props.navigation.current;
  const isShow = useSelector((state) => state.modal.actionReview.isShow);
  const review = useSelector((state) => state.modal.actionReview.data);
  const modalizeRef = useRef(null);
  const screen = isWeb ? 'EditReviewScreenDesktop' : 'EditReviewScreen';

  const closeModal = async () => {
    await dispatch({ type: 'MODAL/HIDE', modalName: 'actionReview' });
  };

  const showModalRequestToDelete = async () => {
    await dispatch({
      type: 'MODAL/SHOW',
      modalName: 'requestToDeleteReview',
      data: review,
    });
    closeModal();
  };

  const navigateToEditReviewHandler = () => {
    closeModal();
    dispatch({
      type: 'editReview/setState',
      name: 'selectedReview',
      value: review,
    });
    navigation.navigate(screen, { id: review?.product?.id });
  };

  useEffect(() => {
    if (isShow) {
      modalizeRef.current?.open();
    } else {
      modalizeRef.current?.close();
    }
  }, [isShow]);

  return (
    <ModalizeBase
      withInsetsBottom={true}
      ref={modalizeRef}
      onClosed={closeModal}>
      {isShow && (
        <View style={styles.modalContainer}>
          <View style={styles.modalHeader}>
            <Text style={styles.modalHeaderHeading}>Action</Text>
            <Pressable style={styles.modalDismiss} onPress={closeModal}>
              <WithLocalSvg
                key="dismiss"
                width={14}
                height={14}
                asset={dismissSource}
                onPress={closeModal}
              />
            </Pressable>
          </View>

          <View style={styles.modalBody}>
            {review.is_editable && (
              <Pressable
                style={styles.actionItemContainer}
                onPress={navigateToEditReviewHandler}>
                <Text style={styles.actionItemText}>Edit Review</Text>
              </Pressable>
            )}

            <Pressable
              style={styles.actionItemContainer}
              onPress={showModalRequestToDelete}>
              <Text style={[styles.actionItemText, { color: '#EF6354' }]}>
                Request to Delete
              </Text>
            </Pressable>
          </View>
        </View>
      )}
    </ModalizeBase>
  );
};

const styles = StyleSheet.create({
  actionItemContainer: {
    paddingVertical: 15,
  },
  actionItemText: {
    fontFamily: 'figtree-medium',
    fontSize: 14,
    lineHeight: 19,
    color: '#25182E',
  },
  modalBody: {},
  modalContainer: {
    paddingHorizontal: 16,
    paddingBottom: 24,
    paddingTop: 20,
    // minHeight: 276
  },
  modalDismiss: {
    position: 'absolute',
    right: 4,
    top: 3,
  },
  modalHeader: {
    position: 'relative',
    marginBottom: 16,
  },
  modalHeaderHeading: {
    fontFamily: 'figtree-black',
    fontSize: 17,
    lineHeight: 23,
    color: '#25182E',
  },
});

export default ModalActionReview;
